export const CONFIG = Object.freeze({
  BASE_URL: `https://witrino.com`,
  VERSION: "",
});
export const CONFIG_MOCK = Object.freeze({
  BASE_URL: `http://192.168.1.107:8000`,
  VERSION: "",
});
